document.addEventListener('DOMContentLoaded', () => {
  const tabsContainers = document.querySelectorAll('.tabs-upsell');

  tabsContainers.forEach(container => {
    const tabs = container.querySelectorAll('.tabs-upsell__tab');
    const panels = container.querySelectorAll('.tabs-upsell__panel');
    const content = container.querySelector('.tabs-upsell__content');

    // Function to set container height based on active panel
    const setContainerHeight = () => {
      const activePanel = container.querySelector('.tabs-upsell__panel--active');
      if (activePanel && content) {
        content.style.height = activePanel.offsetHeight + 'px';
      }
    };

    // Wait for images to load before setting initial height
    const images = container.querySelectorAll('img');
    let loadedImages = 0;
    const totalImages = images.length;

    if (totalImages > 0) {
      images.forEach(img => {
        if (img.complete) {
          loadedImages++;
          if (loadedImages === totalImages) {
            setContainerHeight();
          }
        } else {
          img.addEventListener('load', () => {
            loadedImages++;
            if (loadedImages === totalImages) {
              setContainerHeight();
            }
          });
        }
      });
    } else {
      setContainerHeight();
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetTab = tab.getAttribute('data-tab');

        tabs.forEach(t => t.classList.remove('tabs-upsell__tab--active'));
        panels.forEach(p => p.classList.remove('tabs-upsell__panel--active'));

        tab.classList.add('tabs-upsell__tab--active');

        setTimeout(() => {
          const targetPanel = container.querySelector(`[data-panel="${targetTab}"]`);
          if (targetPanel && content) {
            targetPanel.classList.add('tabs-upsell__panel--active');
            // Set height to new panel height for smooth transition
            content.style.height = targetPanel.offsetHeight + 'px';
          }
        }, 50);
      });
    });

    // Add to Cart functionality
   /* const addToCartButtons = container.querySelectorAll('.tabs-upsell__add-to-cart');
    
    addToCartButtons.forEach(button => {
      button.addEventListener('click', async (e) => {
        e.preventDefault();
        
        const variantId = button.getAttribute('data-variant-id');
        const originalText = button.textContent;
        
        button.classList.add('tabs-upsell__add-to-cart--loading');
        button.textContent = 'Adding...';
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1
              }]
            })
          });
          
          if (response.ok) {
            button.textContent = 'Added!';
            
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
            
            setTimeout(() => {
              button.textContent = originalText;
              button.classList.remove('tabs-upsell__add-to-cart--loading');
            }, 1500);
          } else {
            throw new Error('Failed to add to cart');
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          button.textContent = 'Error';
          setTimeout(() => {
            button.textContent = originalText;
            button.classList.remove('tabs-upsell__add-to-cart--loading');
          }, 1500);
        }
      });
    });*/
  });
});